{
  "schemaVersion": 1,
  "id": "media-toolkit",
  "version": "1.0.0",
  "name": "FFmpeg Media Toolkit",
  "description": "Convert, compress, resize, trim, extract, animate, and remix local video and audio files.",
  "categories": ["Video", "Audio"],
  "icon": "clapperboard",
  "script": "run.mjs",
  "interface": {
    "type": "html",
    "entry": "ui.html"
  },
  "requiredExecutables": [{ "name": "ffmpeg" }],
  "configuration": []
}
